import { useCallback, useEffect, useState } from "react";
import Carousel from "react-multi-carousel";
import { Legend } from "../Legend/Legend";
import { Loader } from "semantic-ui-react";
import "react-multi-carousel/lib/styles.css";
import "./NclpParameters.css";
import { IParameter } from "../../models/parameter";
import { getParamtersToSubmit } from "../../services/parametersService";
import { NclpParameterCard } from "../../containers/ParameterCard/NclpParameterCard";
import { responsiveCarousel } from "../../helpers/commonHelper";

interface IProps {
    withLegend?: boolean;
}

export const NclpParameters = ({ withLegend }: IProps) => {
    const [parameters, setParameters] = useState<IParameter[]>([]);
    const [loading, setLoading] = useState(true);
    const [timeoutRef, setTimeoutRef] = useState<NodeJS.Timeout>();

    const fetchParamtersToSubmit = useCallback(async () => {
        const fetch = async (withLoading: boolean) => {
            setLoading(withLoading);
            const res = await getParamtersToSubmit();
            setParameters(res);
            setLoading(false);
        };
        await fetch(true);

        let timeout = setTimeout(async () => {
            await fetch(false);
            setTimeoutRef(undefined);
        }, 2500);
        setTimeoutRef(timeout);
    }, []);

    useEffect(() => {
        fetchParamtersToSubmit();
    }, [fetchParamtersToSubmit]);

    useEffect(() => {
        return () => {
            if (timeoutRef) {
                clearTimeout(timeoutRef);
            }
        };
    }, [timeoutRef]);

    return (
        <div>
            <div className="section-title">
                <h1>Parameters to submit</h1>
                {withLegend && parameters.length > 0 && <Legend new partial />}
            </div>

            <div id="parameters-content">
                <div className="parameters-list">
                    <Loader active={loading} inline="centered" />
                    <Carousel responsive={responsiveCarousel}>
                        {parameters
                            .filter(p => !p.summary)
                            .map(x => (
                                <div className="action-bar-container" key={x.guid}>
                                    <NclpParameterCard parameter={x} />
                                </div>
                            ))}
                    </Carousel>
                    {parameters.length === 0 && !loading && <b>No parameters to submit.</b>}
                </div>
            </div>
        </div>
    );
};
